import Cookies from 'js-cookie';

export const i18n = {
  locale: (Cookies.get('ereg-app-locale') || 'en') as 'en' | 'de' | 'es' | 'pl',

  activate: (locale: 'en' | 'de' | 'es' | 'pl') => {
    if (!i18n.locales().find((e) => e.value === locale)) {
      console.error('Unsupported locale: ' + locale + ', falling back to english (en)');
      locale = 'en';
    }

    Cookies.set('ereg-app-locale', locale);
    i18n.locale = locale;
  },

  init: () => {
    i18n.activate(i18n.locale);
  },

  locales: (supportedLocales?: string) => {
    const locales = [
      {
        label: 'English',
        value: 'en',
        flag: '🇬🇧',
      },
      {
        label: 'Deutsch',
        value: 'de',
        flag: '🇩🇪',
      },
      {
        label: 'Español',
        value: 'es',
        flag: '🇪🇸',
      },
      {
        label: 'Polski',
        value: 'pl',
        flag: '🇵🇱',
      },
    ];

    return locales.filter((l) => !supportedLocales || supportedLocales.indexOf(l.value) > -1);
  },

  countries: (cc: string) => {
    const countries = [
      {
        label: {
          de: 'Deutschland',
          en: 'Germany',
          es: 'Alemania',
        },
        cc: 'DE',
        flag: '🇩🇪',
      },
      {
        label: {
          de: 'Chile',
          en: 'Chile',
          es: 'Chile',
        },
        cc: 'CL',
        flag: '🇨🇱',
      },
      {
        label: {
          de: 'Vereinigtes Königreich',
          en: 'United Kingdom',
          es: 'Reino Unido',
        },
        cc: 'GB',
        flag: '🇬🇧',
      },
      {
        label: {
          de: 'Vereinigte Staaten',
          en: 'United States of America',
          es: 'Estados Unidos',
        },
        cc: 'US',
        flag: '🇺🇸',
      },
      {
        label: {
          de: 'Indien',
          en: 'India',
          es: 'India',
        },
        cc: 'IN',
        flag: '🇮🇳',
      },
      {
        label: {
          de: 'Polen',
          en: 'Poland',
          es: 'Poland',
        },
        cc: 'PL',
        flag: '🇵🇱',
      },
      {
        label: {
          de: 'Südafrika',
          en: 'South Africa',
          es: 'Sudáfrica',
        },
        cc: 'ZA',
        flag: '🇿🇦',
      },
    ];

    return countries.filter((c) => !cc || cc === c.cc);
  },
};

i18n.init();
